// 字符串转数字
export const convertNumericStrings = (obj) => {
  if (typeof obj !== 'object' || obj === null) {
    // 如果不是对象或数组，或者值为null，则直接返回  
    return obj;
  }

  if (Array.isArray(obj)) {
    // 如果是数组，递归处理每个元素  
    return obj.map(item => convertNumericStrings(item));
  }

  // 如果是对象，递归处理每个属性值  
  const newObj = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      if (typeof value === 'string' && /^\d+(\.\d+)?$/.test(value)) {

        // 如果字符串只包含数字（可能有小数点），则检查长度并转换  
        if (value.length > 15) {

          newObj[key] = value; // 保持为字符串  
        } else {
          const num = parseFloat(value); // 尝试转换为浮点数  
          // 检查转换后是否为有效数字  
          if (!isNaN(num)) {
            newObj[key] = Number(num); // 转换为数字  
          } else {

            newObj[key] = value; // 转换失败，保持原字符串  
          }
        }
      } else {
        // 如果不是字符串或不是纯数字字符串，递归处理  
        newObj[key] = convertNumericStrings(value);
      }
    }
  }
  return newObj;
}

// 数字转字符串
export function numberStringConversion(baseStr) {

  if (!baseStr || typeof baseStr != "string") return;

  // 替换超出 15位的 数字类型范围的整数为字符串
  const replacedStr = baseStr.replace(/(?<=\|,|\s|^)(-?\d{17,})(?=,|\s|\]|"$)|(?<=\[|,|\s|^)(?<=",)(-?\d{17,})(?=,|\s|\]|"$)|(?<="[^"]+":\s*)(-?\d{17,})/g, match => {
    return `"${match}"`
  });
  // console.log(replacedStr)
  try {
    const jsonData = JSON.parse(replacedStr);
    // console.log(jsonData)
    return jsonData;
  } catch (err) {
    console.error("Error parsing JSON:", err);
    return null;
  }

}

